import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { Notify, PrintingService, MessageService, ConfigService, Email} from 'baseline-lib';
import { Http } from '@angular/http';
import { SimpleChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { BetRequest, gameType ,SharedService} from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';
import { TranslateService } from '@ngx-translate/core';



/**
 * Generated class for the BookBetPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-book-bet',
  templateUrl: 'book-bet.html',
})
export class BookBetPage {
  emailtoggle: boolean = false;
  currencySymbol: string;
  emailAddress: string = null;
  bookBetCss: any = '';
  _notify: Notify;
  bookBetObj: BetRequest;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private _printingService: PrintingService,
    private _configService: ConfigService,
    private _messageService: MessageService,
    public translate : TranslateService,
    private _sharedService: SharedService,
    private toast: CustomToast,
    private _http: Http) {
      this.currencySymbol = this._sharedService._sessionService.getCurrenySymbol();
      // console.log(this._http.get("./book-bet.email.css"));
      this.bookBetObj = this.navParams.get('data');
      this._notify = new Notify();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BookBetPage');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.bookBetObj) {
      this._notify = new Notify();
      this.bookBetObj = changes.bookBetObj.currentValue as any;
      this.parseBookBetObj();

      this._http.get("assets/css/book-bet.email.css")
        .subscribe(data => {
          this.bookBetCss = data.text();
        });
    }
  }


  parseBookBetObj() {
    if (this.bookBetObj) {
      switch (this.bookBetObj.gt) {
        case gameType.lotto:

          this.bookBetObj.pli.forEach(_betP => {
            _betP.EventName = _betP.gameName
            _betP.MarketName = _betP.betTypeName;
            _betP.RaceEventId = _betP.drawNo;
            _betP.eid = _betP.did;
            if (_betP.sn)
              _betP.Description = _betP.sn;
            else
              _betP.Description = _betP.sli.toString();
          });

          break;

        case gameType.sports:
          break;

      }
    }
  }

    // click on send email
    sendEmail() {

      if (this.emailAddress != null && this.emailAddress.trim() != '') {
        var emailObj = new Email(this.emailAddress, this.generateEmailTemplate(), this.bookBetObj.tn);
        this._messageService.sendBookABetEmail(emailObj).subscribe(data => {
          if (data.status == 200) {
            this.translate.get('Booking Sent via Email').subscribe(
              value => 
              {
                this.toast.showSuccess(value);
              });

            setTimeout(() => {
              this._notify.successMsg = '';
              this.cancelMail();
              document.getElementById("closeBtn").click();
            }, 3000);
          }
        },
          error => {
            if (error.msg) {
              this.toast.showError(error.msg);
            }
            else {
              this.toast.showError(error.message);
            }
          });
  
      }
    }

    // click on dialog close
    resetBookABet() {
      this.bookBetObj = new BetRequest();
      this.navCtrl.pop();
      this._sharedService.openBookABet.next(null);
    }

    cancelMail() {
      this.emailtoggle = false;
      this.emailAddress = null;
    }

    generateEmailTemplate(): any {
      let bookBetTemplate = '';
      bookBetTemplate = '<html> <head> <style> ' + this.bookBetCss + '</style> </head> ';
      bookBetTemplate += '<body> ' + document.getElementById("bookBetMainPanel").innerHTML + '</body> </html> ';
      return bookBetTemplate;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/book-bet/book-bet.ts